import { ENDPOINTS } from '../constants';
import { parseResponse, defaultHeaders } from '../utils';

class CityService {
  async getCities() {
    // 60 segundos * 60 minutos * 24 horas * 7 dias
    const cacheMaxAge = 7 * 24 * 60 * 60;
    const response = await fetch(ENDPOINTS.CITIES, {
      method: 'GET',
      headers: defaultHeaders(
        { 'cache-control': `max-age=${cacheMaxAge}` },
      ),
    });

    return parseResponse(response);
  }

  async getCity(id, options = {}) { // Define um objeto padrão vazio para 'options'
    const cacheMaxAge = 7 * 24 * 60 * 60;
    // Garanta que ENDPOINTS.CITY seja chamado corretamente.
    const response = await fetch(ENDPOINTS.CITY(id, options), { // Use 'options' corretamente aqui
      method: 'GET',
      headers: defaultHeaders({
        'cache-control': `max-age=${cacheMaxAge}`,
      }),
    });

    return parseResponse(response);
  }

  async addUser(cityId, userId) {
    const response = await fetch(ENDPOINTS.CITY_USER(cityId, userId), {
      method: 'PUT',
      headers: defaultHeaders(),
    });

    return parseResponse(response);
  }

  async removeUser(cityId, userId) {
    const response = await fetch(ENDPOINTS.CITY_USER(cityId, userId), {
      method: 'DELETE',
      headers: defaultHeaders(),
    });

    return parseResponse(response);
  }

  async addVendors(cityId, users) {
    const response = await fetch(ENDPOINTS.CITY(cityId), {
      method: 'PUT',
      headers: defaultHeaders(),
      body: JSON.stringify({ users }),
    });

    return parseResponse(response);
  }

  async removeVendors(cityId, users) {
    const response = await fetch(ENDPOINTS.CITY(cityId), {
      method: 'DELETE',
      headers: defaultHeaders(),
      body: JSON.stringify({ users }),
    });

    return parseResponse(response);
  }

  async getCitiesByIds(cityIds) {
    const promises = cityIds.map((id) => this.getCity(id));
    console.log(promises);
    return Promise.all(promises);
  }
}

export default new CityService();
